import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import ArrowBack from '@mui/icons-material/ArrowBack';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

interface VaultMatterHeaderProps {
  matterName: string;
  onBack: () => void;
  isLoading?: boolean;
}

export default function VaultMatterHeaderOld({
  matterName,
  onBack,
  isLoading,
}: VaultMatterHeaderProps) {
  return (
    <>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton
          onClick={onBack}
          size="small"
          sx={{ ml: -1 }}
          disabled={isLoading}
        >
          <ArrowBack fontSize="small" />
        </IconButton>
        {isLoading ? (
          <>
            <Skeleton variant="text" width={100} height={30} />
            <KeyboardArrowRight fontSize="small" color="action" />
            <Skeleton variant="text" width={200} height={30} />
          </>
        ) : (
          <>
            <Typography
              variant="h6"
              fontWeight={500}
              color="text.secondary"
              sx={{ cursor: 'pointer' }}
              onClick={onBack}
            >
              Matters
            </Typography>
            <KeyboardArrowRight fontSize="small" color="action" />
            <Typography variant="h6" fontWeight={500}>
              {matterName}
            </Typography>
          </>
        )}
      </Stack>
      <Divider />
    </>
  );
}
